<template>
  <div class="fixed right-4 z-50 flex flex-col items-center gap-2" style="top: 50%; transform: translateY(-50%);">
    <!-- Theme toggle button -->
    <button
      @click="toggleTheme($event)"
      class="group relative w-12 h-12 rounded-full shadow-lg transition-all duration-500 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
      :class="isDark
        ? 'bg-gradient-to-br from-indigo-900 to-purple-900 text-yellow-300'
        : 'bg-gradient-to-br from-primary-400 to-orange-500 text-white'"
      :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
      :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
    >
      <!-- Sun icon (shown in dark mode) -->
      <i
        v-if="isDark"
        class="pi pi-sun text-xl transition-transform duration-500 group-hover:rotate-180"
      ></i>
      <!-- Moon icon (shown in light mode) -->
      <i
        v-else
        class="pi pi-moon text-xl transition-transform duration-500 group-hover:-rotate-12"
      ></i>

      <!-- Decorative glow ring -->
      <span
        class="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        :class="isDark
          ? 'shadow-[0_0_15px_rgba(250,204,21,0.4)]'
          : 'shadow-[0_0_15px_rgba(255,111,0,0.4)]'"
      ></span>
    </button>

    <!-- Tooltip label -->
    <span
      class="text-[10px] font-medium px-2 py-0.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none select-none"
      :class="isDark ? 'bg-neutral-800 text-neutral-300' : 'bg-theme-card text-theme-text2 shadow'"
    >
      {{ isDark ? 'Light' : 'Dark' }}
    </span>
  </div>
</template>

<script setup>
import { useTheme } from '@/composables/useTheme.js'

const { isDark, toggleTheme } = useTheme()
</script>
